// ---------------------------------------------
// auto-generated from screens/hub-hoy.jsx
// edit the source there and run `npm run sync`
// ---------------------------------------------
import React from "react";
import { Icon, Chip, Eyebrow, StatusBar, Candles, genCandles } from "./primitives.jsx";

// ─────────────────────────────────────────────────────────
//  HUB · Hoy  (mobile portrait 390×844)
// ─────────────────────────────────────────────────────────
export const ScreenHubHoy = () => {
  const candleData = React.useMemo(() => genCandles(36, 4, { trend: 0.4, vol: 1.0, base: 100 }), []);
  return (
    <div className="screen-m ef" data-screen-label="Hub · Hoy">
      <StatusBar/>
      {/* App bar */}
      <div style={{ padding: "4px 20px 0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div className="mono" style={{ fontSize: 10.5, letterSpacing: "0.16em", color: "var(--accent)", textTransform: "uppercase" }}>EducaFinaz</div>
          <div style={{ fontSize: 24, fontWeight: 600, letterSpacing: "-0.02em", marginTop: 2 }}>Buenos días, Marta</div>
        </div>
        <div className="icon-btn" style={{ width: 40, height: 40 }}><Icon name="search" size={18}/></div>
      </div>

      {/* Streak + nivel + repaso */}
      <div style={{ padding: "14px 20px 0", display: "flex", gap: 8 }}>
        <Chip variant="live">racha · 12 días</Chip>
        <Chip variant="neutral">nivel · medio</Chip>
        <Chip variant="warn">repaso · 3</Chip>
      </div>

      {/* HERO: continúa */}
      <div style={{ padding: "16px 20px 0" }}>
        <Eyebrow>Continúa donde lo dejaste</Eyebrow>
        <div className="glass" style={{ marginTop: 8, padding: 14, borderRadius: 16, position: "relative", overflow: "hidden" }}>
          <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 8 }}>
            <Chip>EXPLICA · 7 min</Chip>
            <Chip variant="neutral">acto 3 de 7</Chip>
          </div>
          <div style={{ fontSize: 18, fontWeight: 600, lineHeight: 1.2, letterSpacing: "-0.01em" }}>
            Ruptura o falsa ruptura
          </div>
          <div style={{ fontSize: 12.5, color: "var(--text-2)", marginTop: 4, lineHeight: 1.4 }}>
            Soportes, resistencias y volumen
          </div>
          {/* mini chart */}
          <div style={{ marginTop: 12, marginBottom: 10, borderRadius: 10, overflow: "hidden", background: "rgba(6,15,34,0.4)" }}>
            <Candles data={candleData} width={310} height={86} padding={4}
              overlays={[
                { type: "zone", from: 99.5, to: 101.5, color: "primary", label: "R" },
                { type: "marker", x: 24, y: 102.2, label: "cierre fuera" },
              ]} showVolume={false}/>
          </div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ width: 88, height: 4, background: "rgba(168,185,217,0.15)", borderRadius: 4, overflow: "hidden" }}>
                <div style={{ width: "42%", height: "100%", background: "var(--accent)" }}/>
              </div>
              <span className="mono" style={{ fontSize: 10.5, color: "var(--text-3)" }}>02:54 / 07:00</span>
            </div>
            <button className="btn primary sm" style={{ height: 32 }}>
              <Icon name="play" size={12}/> Reanudar
            </button>
          </div>
        </div>
      </div>

      {/* repaso pendiente */}
      <div style={{ padding: "14px 20px 0" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
          <Eyebrow>Repaso pendiente · 3 cards</Eyebrow>
          <span style={{ fontSize: 11, color: "var(--text-3)" }}>ver todo</span>
        </div>
        <div style={{ display: "flex", gap: 8, overflow: "hidden" }}>
          {[
            { t: "Tendencia ≠ vela aislada", d: "día 3" },
            { t: "Soporte es zona, no línea", d: "día 4" },
            { t: "RSI alto ≠ vender", d: "día 10" },
          ].map((c, i) => (
            <div key={i} className="glass" style={{ flex: "0 0 130px", padding: 10, borderRadius: 12 }}>
              <Icon name="lightbulb" size={14} style={{ color: "var(--warn)" }}/>
              <div style={{ fontSize: 12, fontWeight: 600, lineHeight: 1.25, marginTop: 8, textWrap: "pretty" }}>{c.t}</div>
              <div className="mono" style={{ fontSize: 9.5, color: "var(--text-3)", marginTop: 6, letterSpacing: "0.08em" }}>{c.d}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Flash del día */}
      <div style={{ padding: "14px 20px 0" }}>
        <Eyebrow>Flash del día</Eyebrow>
        <div className="glass" style={{ marginTop: 8, padding: 12, borderRadius: 14, display: "flex", gap: 10, alignItems: "center" }}>
          <div style={{
            width: 56, height: 70, borderRadius: 8, flexShrink: 0,
            background: "linear-gradient(135deg, rgba(127,182,255,0.25), rgba(95,214,193,0.18))",
            display: "grid", placeItems: "center", border: "1px solid rgba(127,182,255,0.3)"
          }}>
            <Icon name="spark" size={18} style={{ color: "var(--primary)" }}/>
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: "flex", gap: 6 }}><Chip>FLASH · 20s</Chip></div>
            <div style={{ fontSize: 14, fontWeight: 600, marginTop: 6, lineHeight: 1.25 }}>
              Una tendencia no es una línea recta
            </div>
            <div style={{ fontSize: 11.5, color: "var(--text-2)", marginTop: 2 }}>microacción · tap-select</div>
          </div>
          <Icon name="next" size={18} style={{ color: "var(--text-3)" }}/>
        </div>
      </div>

      {/* Próximo en tu ruta */}
      <div style={{ padding: "14px 20px 0" }}>
        <Eyebrow>Próximo en tu ruta · AT iniciación</Eyebrow>
        <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
          <div className="glass" style={{ flex: 1, padding: 12, borderRadius: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <Icon name="map" size={14} style={{ color: "var(--accent)" }}/>
              <span className="mono" style={{ fontSize: 9.5, color: "var(--text-3)", letterSpacing: "0.1em" }}>M3 · TENDENCIAS</span>
            </div>
            <div style={{ fontSize: 13.5, fontWeight: 600, marginTop: 8, lineHeight: 1.25 }}>Estructura y secuencia</div>
            <div className="mono" style={{ fontSize: 10, color: "var(--text-3)", marginTop: 6 }}>35 min · lab incluido</div>
          </div>
          <div className="glass" style={{ flex: 1, padding: 12, borderRadius: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <Icon name="headset" size={14} style={{ color: "var(--primary)" }}/>
              <span className="mono" style={{ fontSize: 9.5, color: "var(--text-3)", letterSpacing: "0.1em" }}>AUDIO · COMMUTE</span>
            </div>
            <div style={{ fontSize: 13.5, fontWeight: 600, marginTop: 8, lineHeight: 1.25 }}>Recap M2 + 1 verbal</div>
            <div className="mono" style={{ fontSize: 10, color: "var(--text-3)", marginTop: 6 }}>4:20 · sin pantalla</div>
          </div>
        </div>
      </div>

      {/* Bottom nav */}
      <div style={{
        position: "absolute", bottom: 0, left: 0, right: 0, height: 88,
        background: "linear-gradient(180deg, rgba(10,23,48,0) 0%, rgba(6,15,34,0.85) 35%, rgba(6,15,34,0.95) 100%)",
        backdropFilter: "blur(12px)",
        display: "flex", justifyContent: "space-around", alignItems: "flex-start", paddingTop: 12,
      }}>
        {[
          { i: "today", l: "Hoy", on: true },
          { i: "map", l: "Aprender" },
          { i: "explore", l: "Explora" },
          { i: "review", l: "Repaso", badge: 3 },
          { i: "profile", l: "Perfil" },
        ].map((n, i) => (
          <div key={i} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4, position: "relative" }}>
            <Icon name={n.i} size={20} style={{ color: n.on ? "var(--accent)" : "var(--text-3)" }}/>
            <span style={{ fontSize: 10, color: n.on ? "var(--text)" : "var(--text-3)", fontWeight: n.on ? 600 : 400 }}>{n.l}</span>
            {n.badge && (
              <span style={{
                position: "absolute", top: -2, right: -10, background: "var(--warn)", color: "#1c1306",
                fontSize: 9, fontWeight: 700, padding: "1px 5px", borderRadius: 99, fontFamily: "var(--t-mono)"
              }}>{n.badge}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
